import {useCallback} from "react";
import Button from "../button/Button";
import Input from "../input/Input";
import {useTranslation} from "react-i18next";
import "./_pagination.scss";

function TableGridPaginationSmall({page, setPage, maxPage}) {
    const decrementPage = useCallback(() => {
        setPage((page) => page - 1);
    }, [setPage]);

    const incrementPage = useCallback(() => {
        setPage((page) => page + 1);
    }, [setPage]);

    return (
        <div className="pagination small-pagination">
            <Button
                buttonStyle={"round"}
                icon={<i className="fas fa-backward" />}
                onClick={decrementPage}
                disabled={page === 0}
            />
            <Button
                buttonStyle={"round"}
                icon={<i className="fas fa-forward" />}
                onClick={incrementPage}
                disabled={page === maxPage}
            />
        </div>
    );
}

function TableGridPaginationBig({
    page,
    setPage,
    maxPage,
    paginatedData,
    data,
    setPaginationItems,
    paginationItems,
}) {
    const {t} = useTranslation();

    const resetPage = useCallback(() => {
        setPage(0);
    }, [setPage]);

    const decrementPage = useCallback(() => {
        setPage((page) => page - 1);
    }, [setPage]);

    const incrementPage = useCallback(() => {
        setPage((page) => page + 1);
    }, [setPage]);

    const setMaxPage = useCallback(() => {
        setPage(maxPage);
    }, [setPage, maxPage]);

    const onPaginationAmountChange = useCallback(
        (value) => {
            setPaginationItems(+value);
        },
        [setPaginationItems]
    );

    return (
        <div className="pagination">
            <div className="items-amount">
                {t("tableGrid.displaying", {
                    type1: paginatedData.length,
                    type2: data.length,
                })}
            </div>
            <div className="pagination-buttons">
                <Button
                    type={"button"}
                    buttonStyle={"round"}
                    icon={<i className="fas fa-step-backward" />}
                    onClick={resetPage}
                />
                <Button
                    type={"button"}
                    buttonStyle={"round"}
                    icon={<i className="fas fa-backward" />}
                    onClick={decrementPage}
                    disabled={page === 0}
                />
                <span>
                    {page + 1}/{maxPage + 1}
                </span>
                <Button
                    type={"button"}
                    buttonStyle={"round"}
                    icon={<i className="fas fa-forward" />}
                    onClick={incrementPage}
                    disabled={page === maxPage}
                />
                <Button
                    type={"button"}
                    buttonStyle={"round"}
                    icon={<i className="fas fa-step-forward" />}
                    onClick={setMaxPage}
                />
                <Input
                    type="number"
                    value={paginationItems}
                    onChange={onPaginationAmountChange}
                />
            </div>
        </div>
    );
}

export default function Pagination({
    page,
    setPage,
    smallPagination,
    data,
    paginatedData,
    paginationItems,
    maxPage,
    setPaginationItems,
}) {
    if (smallPagination)
        return (
            <TableGridPaginationSmall
                page={page}
                setPage={setPage}
                maxPage={maxPage}
            />
        );
    return (
        <TableGridPaginationBig
            page={page}
            setPage={setPage}
            data={data}
            maxPage={maxPage}
            paginatedData={paginatedData}
            paginationItems={paginationItems}
            setPaginationItems={setPaginationItems}
        />
    );
}
